module.exports = __webpack_public_path__ + "media/images/sp/plans/reason_02-79b21a3aba9e4a99c92178327a5dc23c.jpg";